import * as actionTypes from './actionsTypes';

export const setBackUpResponse = (loadedResponse) => {
  return {
    type: actionTypes.SETBACKUPRESPONSE,
    data: loadedResponse,
  };
};
